/**
 * editor与player的连接管理模块
 * @author hudk
 */
import React, { Component, CSSProperties, lazy, Suspense } from 'react';
import '@tencent/dui/lib/utils/polyfill';
import '@tencent/dui-mobile/lib/utils/polyfill';
import { setDefaultConfiguration } from '@tencent/tencent_doc_open_url';
import Editor from '@editor/src/page/index/container';
import Styles from './style.less';
import '@utils/event-manage/resize';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import {
    isLocalDebug,
} from 'utils';
import { resetDefaultTdwData } from '@tencent/tencent-doc-report';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Modal from '@tencent/dui/lib/components/Modal';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWOperationType, TDWModuleType, TDWActionType, TDWVer10Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import '../God'; // DO NOT DELETE
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { VipToastService } from '@utils/vipToast';
import ErrorBoundary from '@framework/frame/components/error-boundary';
import i18n from '@i18next/i18n';
import { MEETING_SCENE_SOURCE } from '@src/page/toc/common/meeting-room-manager/message_const';
import AccessibilityConstants from '@src/slide/application/service/accessibility-manager/core/accessibility-constants';
import { TRANSITION_EVENT_TYPE } from '@src/js/service/boot-service/boot-manager.interface';
import { PCBootManager } from '@src/js/service/boot-service/boot-manager-pc';
import '@src/js/manager/load-manager';
import FullscreenHandler from '@utils/fullscreen/fullscreen-handler';
import SingleSnackbar from '@utils/single-snackbar';
import { closeLoadingInTencentMeeting, initInTencentMeeting } from '@utils/tencent-meeting';
import { CUSTOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { changeFavicon } from '../favicon-manager';
import { postMessageToDrive } from '../drive-manager';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { showFirstScreenTip } from '@src/js/common/tips';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { onSlideAppReady, SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { needShowBlank } from '../check-client-vars';
import AsyncBoundary from '@src/framework/frame/components/async-boundary';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import type Accessibility from '@src/slide/application/service/accessibility-manager/core/accessibility';
import { isEditableDriveFile, isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

const PresenterView = lazy(() => import(/* webpackChunkName: "presenter-view" */ '@framework/presenter-view'));
const MeetingRoomEntry = lazy(() => import(/* webpackChunkName: "meetingroom" */ '@src/page/toc/common/meeting-room-manager/editor-entry'));
const MobileRemoteControlPCContainer = lazy(() => import(/* webpackChunkName: "meetingroom" */ '@src/page/toc/common/meeting-room-manager/components/mobile-remote-control/pc-container'));
const singleSnackbar = new SingleSnackbar({ Snackbar });

let fTurnOnLaser: any = null;
let store: any = null;

interface ManagerProps {}

interface ManagerState {
    play?: boolean;
    appReady?: boolean;
    currentPage?: number;
    currentFragment?: number;
    data?: any;
    remotePlay?: boolean;
    mobileRemoteControl?: boolean;
}
export default class Manager extends Component<ManagerProps, ManagerState> {
    private editorRef;
    private Accessibility: typeof Accessibility;
    public constructor(props) {
        super(props);

        // TODO 这两个state应当来源于ui store，并暴露方法
        this.state = {
            play: false,
            appReady: false,

            // Player props
            currentPage: 0,
            currentFragment: 0,
            data: {},
            // 未初始化
            // laserTurnOn,
            // remotePlay,
        };
        this.editorRef = null;

        // 以后，通过祈祷，就可以和上帝对话了
        // window.pray = () => { return God.myGod() };
        window.pray().blessManager(() => this.state);
        PCBootManager.bootStateMachine.executeByEvent(TRANSITION_EVENT_TYPE.infrastructureDidReadyEvent);

        eventBus.on(EventKeys.FIRST_PAGE_DISPLAY, () => {
            import(/* webpackChunkName: "player" */ '@player/src/actions/control')
                .then(({ turnOnLaser }) => {
                    fTurnOnLaser = turnOnLaser;
                })
                .catch((error) => {
                    window.log.error(`[loadChunk-error]${error}`);
                });
            this.getAccessibilityManager().promise()
                .then((a11yManager) => {
                    this.Accessibility = a11yManager.Accessibility;
                });
        });
        closeLoadingInTencentMeeting();
        initInTencentMeeting();
        // 桌面端本地编辑 & 云编需替换favicon
        if (ENV.IS_PC_LOCAL_EDIT || isEditableDriveFile()) {
            changeFavicon(CUSTOM.FAVICON.SLIDE);
        }
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillMount() {
        // B 端没有回收站逻辑
        if (config.supportEnterprise(EnterPriseType.ALL)) return;

        // 文档删除、还原
        this.getDocRecoverService()?.setShowDialogCallback(this.showTrashDialog);
        this.getDocRecoverService()?.initialize();
    }

    public componentDidMount() {
        // 初始化 tencent_doc_open_url 基础配置
        setDefaultConfiguration({
            ignoreDomainDetect: getCacConfigByKey('custom.common.ignoreUrlDomainDetect', false),
            ignoreHosts: [],
            ignoreDomainDetectCallback: (next: Function) => {
                Modal.confirm({
                    title: i18n.t('即将离开腾讯文档'),
                    content: i18n.t('你即将通过访问链接离开腾讯文档，请注意账号和信息安全，是否继续访问？'),
                    okText: i18n.t('是'),
                    cancelText: i18n.t('否'),
                    onOk: () => next?.(),
                    okButtonType: 'default',
                });
            },
        });
        if (isLocalDebug()) {
            this.setState({
                appReady: true,
            });
        } else {
            // 接口较慢时，window.clientVars后赋值，然后触发SlideApp.onReady、slideApp的addObserverAt
            // 3.0目前数据转换为模拟态，SlideApp.onReady是用window.addEventListener('dataReady')模拟，无法保证和slideApp的addObserverAt的时序
            // 导致presentation的slideHeight的转换晚于updateNeedShowBlank（slide-list的渲染），slide-list渲染时高度读取的是前端默认值，从而出错
            // 等后续事件接完，此处兼容直接干掉即可
            onSlideAppReady(() => {
                Promise.resolve().then(() => {
                    this.needShowBlank();
                    resetDefaultTdwData();
                });
                // ssr 不存在时，获取首页信息后更新左侧栏 & 底部栏预占位
                if (!(window as any).renderData && (window as any).updatePCLeftBarAndFooterPreDom) {
                    SlideDataServices.SlideAppService.promise().then((slideAppService) => {
                        (window as any).updatePCLeftBarAndFooterPreDom(slideAppService.getSlideCount());
                    });
                }
            });
        }
        if (isPreview()) {
            postMessageToDrive(true);
        }

        showFirstScreenTip();
    }

    public componentDidUpdate(_prevProps, prevState) {
        if (prevState.play !== this.state.play) {
            const mediaManager = this.getMediaManager();
            if (this.state.play) {
                // 进入演示态前，清除所有非演示态的音视频播放
                mediaManager.resetAllMobilePreviewMedia();
                mediaManager.resetAllEditorMedia();
            } else {
                // 退出演示态后，清除演示态音视频播放
                mediaManager.resetAllPlayerMedia();
            }
        }
    }

    public render() {
        if (!this.state.appReady) return <div></div>;
        return (
            this.renderEditor()
        );
    }

    private needShowBlank() {
        if (!SlideDataServices.PrivilegeManager()?.readable) {
            (window as any).isBlankPage = true;
        }
        const showBlank = needShowBlank();
        if (showBlank) {
            const docId = SlideDataServices.ClientVarsService()?.getClientVars?.()?.collab_client_vars?.client?.upid;
            this.getAppServices().viewableServiceLayer.blankPageService.showBlankPage(docId || '');
            return;
        }
        this.setState({
            appReady: true,
        });
    }

    /** 进入播放态前，清除页面上的弹窗 */
    private clearDialogBeforePlay = () => {
        // 关闭搜索弹窗
        this.getSearchReplaceManager()?.closeDialog();
        // 关闭通知中心
        this.getNotifyManager().promise()
            .then(notifyManager => notifyManager.hideNotifyContainer());
        // 清除所有页面上的提示, force=true
        Snackbar.closeAll(true);
    };

    /**
     * @param { object } data 展示数据
     * @param { number } currentPage 当前展示页
     * @param { number } currentFragment 当前展示片段 // TODO player未支持
     * @param { boolean } withPresenterView 同时打开演讲者视图独立弹窗
     * @param { boolean } mobileRemoteControl 是否是手机遥控器场景
     */
    private handlePlay = ({
        data, currentPage = 0, currentFragment = 0, laserTurnOn = false, remotePlay = false, withPresenterView = false,
        mobileRemoteControl = false,
    }) => {
        this.clearDialogBeforePlay();
        if (!store) {
            import(/* webpackChunkName: "player" */ '@player/src/store')
                .then((module) => {
                    store = module.default;
                })
                .catch((error) => {
                    window.log.error(`[loadChunk-error]${error}`);
                });
        }
        window.lastWH = `${document.documentElement.clientWidth}_${document.documentElement.clientHeight}`;
        window.intoPlayForResize = true;

        this.updatePageStyle(true);

        window.addEventListener('keydown', this.handleKeyPress);

        if (store)  {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_LOCAL_PLAY,
                action: TDWActionType.INTERFACE,
                ver10: TDWVer10Type.NEW_MENUBAR,
            });
            laserTurnOn && store && store.dispatch(fTurnOnLaser?.());

            this.Accessibility?.emit(AccessibilityConstants.START_PLAY);
        }
        eventBus.emit(EventKeys.START_PLAY);

        const state = this.state.play === true && !mobileRemoteControl
        // 已经处于播放状态且不是遥控器的播放，说明是从本地播放进入远程播放
        // 只切换远程演示 flag，state 中已有的播放数据保留
            ? {  remotePlay: true }
            : {
                data,
                currentPage,
                currentFragment,
                play: true,
                withPresenterView,
                laserTurnOn, // 这里由START_PLAY action使用
                remotePlay,
                mobileRemoteControl,
            };
        this.setState(state, () => {
            if (FullscreenHandler.getInstance().isFullscreen) return;
            // 弹窗与全屏是互斥行为
            if (withPresenterView) return;
            FullscreenHandler.getInstance().requestFullscreen(document.body);
        });

        OnlineEditServices.CollaborationManager()?.suspendAllChanges();
    };

    /* istanbul ignore next */
    private handleEndPlay = (pageIndex) => {
        // TODO 清空router
        window.removeEventListener('keydown', this.handleKeyPress);

        this.setState({
            data: {},
            play: false,
        });

        this.updatePageStyle(false);

        this.getMediaManager()?.handlePlayEnd();
        if (typeof pageIndex === 'number' && pageIndex < this.getUiDataService().presentation.slideCount) {
            // 退出播放时，编辑态跳转到对应的页数
            // TODO: slideStore 重构时提供翻页 api
            this.getSelectionService()?.selectedSlides.clear();
            this.getSelectionService()?.changeCurrentSlideIndexByUserAction(pageIndex);
        }

        if (FullscreenHandler.getInstance().isFullscreen) {
            FullscreenHandler.getInstance().exitFullscreen();
        }
        this.editorRef?.playEndInner?.();
        this.Accessibility?.emit(AccessibilityConstants.END_PLAY);
        eventBus.emit(EventKeys.END_PLAY);

        OnlineEditServices.CollaborationManager()?.resumeAllChanges();
    };

    private updatePageStyle(isPlay) {
        const pages = document.getElementById('pages');
        if (pages) {
            pages.style.display = isPlay ? 'block' : 'none';
        }
    }

    // 无障碍监听播放页切换
    private handlePlayIndexChange = (index) => {
        this.setState({ currentPage: index });
        this.Accessibility?.emit(AccessibilityConstants.PLAY_INDEX_CHANGE, index);
    };

    private handleKeyPress = (e) => {
        if (e.metaKey || e.ctrlKey) {
            if (e.keyCode === 187 || e.keyCode === 189) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    };

    private showTrashDialog = () => {
        Modal.confirm({
            title: i18n.t('提示'),
            content: <span>{i18n.t('回收站中的文档不能编辑，如要使用请还原文档。')}</span>,
            okText: i18n.t('还原'),
            cancelText: i18n.t('取消'),
            onOk: this.confirmTrashRecover,
            onCancel: this.cancelTrashRecover,
        });
    };

    private confirmTrashRecover = () => {
        singleSnackbar.show({ message: i18n.t('还原文件中，请稍后...') });
        // 异步方法
        this.getDocRecoverService()?.recover(() => {
            singleSnackbar.show({
                message: i18n.t('还原成功'),
                type: 'success',
                autoClose: true,
            });
        }, async (code) => {
            const { recoverShowDialog } = await import('@src/js/common/ark-extensions/dc-components/docs-component-size-limit-dialog');
            // 判断属于存储空间超限阻断场景的话，显示开通会员扩容提示, 不再往后走
            const hasShowDialog = await recoverShowDialog(code, () => {
                this.cancelTrashRecover();
            });
            singleSnackbar.close();
            if (hasShowDialog) {
                return;
            }

            // 判断属于vip续期等场景的话，显示vip等提示, 不再往后走
            const hasShowVipToast = await VipToastService.getInstance().showVipToast({ errorCode: code });
            if (hasShowVipToast) {
                return;
            }

            // 都不符合则展示托底异常提示
            const wording = `${i18n.t('还原文件失败，请重试')}${code ? ` (${code})` : ''}。`;
            singleSnackbar.show({
                message: wording,
                type: 'error',
                autoClose: true,
            });
        });
    };

    private cancelTrashRecover = () => {
        this.getDocRecoverService()?.gotoTrash();
        return false;
    };

    private getUiDataService() {
        return this.getAppServices().getUiDataService();
    }

    private getSelectionService() {
        return this.getAppServices().viewableServiceLayer?.selectionService;
    }

    private getPlayManager() {
        return this.getAppServices().viewableServiceLayer?.playManager;
    }

    private getLiveManager() {
        return this.getAppServices().viewableServiceLayer?.liveManager;
    }

    private getMediaManager() {
        return this.getAppServices().viewableServiceLayer?.mediaManager;
    }

    private getSearchReplaceManager() {
        return this.getAppServices().editableServiceLayer?.searchReplaceManager?.dangerousInstance;
    }

    private getEditingPresentManager() {
        return this.getAppServices().viewableServiceLayer?.editingPresentManager;
    }

    private getHistoryManager() {
        return this.getAppServices().editableServiceLayer?.historyManager;
    }

    private getAccessibilityManager() {
        return this.getAppServices().viewableServiceLayer.accessibilityManager;
    }

    private getDocRecoverService() {
        return this.getAppServices().editableServiceLayer?.docRecoverService;
    }

    private getWatermarkManager() {
        return this.getAppServices().viewableServiceLayer?.watermarkManager;
    }

    private getNotifyManager() {
        return this.getAppServices().viewableServiceLayer.notifyManager;
    }

    // eslint-disable-next-line complexity
    private renderEditor() {
        const { isFirefox } = browser;
        const selectNoneStyle: CSSProperties = { // 非火狐，让子元素不可选中
            userSelect: 'none', WebkitUserSelect: 'none',
        };
        const style: CSSProperties = isFirefox ? {} : selectNoneStyle;
        style.width = '100%';
        style.height = '100%';
        const docId = SlideDataServices.ClientVarsService()?.getClientVars?.()?.collab_client_vars?.client?.upid;
        return (
            <div className="manager-wrapper" style={style}>
                <Editor
                    handlePlay={this.handlePlay}
                    handleEndPlay={this.handleEndPlay}
                    style={{ display: this.state.play ? 'none' : 'flex',
                        ...style }}
                    ref={(el) => {
                        this.editorRef = el;
                    }}
                    editingPresentManager={this.getEditingPresentManager()}
                    historyManager={this.getHistoryManager()}
                />
                <div className={Styles['player-wrapper']} style={{ display: this.state.play ? 'block' : 'none' }}>
                    {this.state.play && !this.state.remotePlay && !this.state.mobileRemoteControl
                    && <ErrorBoundary>
                        <Suspense fallback={<div></div>}>
                            <PresenterView
                                handleEndPlay={this.handleEndPlay}
                                sceneSource={MEETING_SCENE_SOURCE.Local}
                                isRoleMaster={true}
                                playIndexChange={this.handlePlayIndexChange}
                                docId={docId || ''}
                                services={{
                                    playManager: this.getPlayManager(),
                                    mediaManager: this.getMediaManager(),
                                    liveManager: this.getLiveManager(),
                                    watermarkManager: this.getWatermarkManager(),
                                }}
                                data={this.state.data || {}}
                                currentPage={this.state.currentPage || 0}
                                currentFragment={this.state.currentFragment || 0}
                                {...this.state}
                            />
                        </Suspense>
                    </ErrorBoundary>
                    }
                    {
                        // 编辑态发起远程演示
                        this.state.play && this.state.remotePlay
                        && <ErrorBoundary>
                            <Suspense fallback={<div></div>}>
                                <AsyncBoundary>
                                    {
                                        async () => {
                                            const liveManager = await this.getLiveManager().promise();
                                            return (
                                                <MeetingRoomEntry
                                                    currentPage={this.state.currentPage || 0}
                                                    roomId={liveManager.roomInfo().roomid}
                                                    handleEndPlay={this.handleEndPlay}
                                                    liveManager={liveManager}
                                                />
                                            );
                                        }
                                    }
                                </AsyncBoundary>
                            </Suspense>
                        </ErrorBoundary>
                    }
                    {
                        this.state.play && this.state.mobileRemoteControl && (
                            <AsyncBoundary>
                                {
                                    async () => {
                                        // eslint-disable-next-line max-len
                                        const remoteControlManager = await this.getAppServices().viewableServiceLayer.remoteControlManager.promise();
                                        return (
                                            <ErrorBoundary>
                                                <Suspense fallback={<div></div>}>
                                                    <MobileRemoteControlPCContainer
                                                        remoteControlManager={remoteControlManager}
                                                        currentPage={this.state.currentPage || 0}
                                                        onPlayEnd={this.handleEndPlay}
                                                    ></MobileRemoteControlPCContainer>
                                                </Suspense>
                                            </ErrorBoundary>
                                        );
                                    }
                                }
                            </AsyncBoundary>
                        )
                    }
                </div>
            </div>
        );
    }

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
